import * as React from 'react';

import AnalyticsService from 'modules/analytics-provider/analytics-provider.service';
import { translate } from 'components/translate-hoc';
import { formatUnit } from '../units-formatter';

import {
    TEXT_KEYS,
    INVITEE_ANALYTICS,
    DEFAULT_STAT_VALUE,
    BUTTON_BUY_ANALYTICS_ACTION
} from './invitee.constants';

import './invitee.styles.less';

import { IInviteeProps } from './invitee.container';

export class Invitee extends React.Component<IInviteeProps> {
    public renderButton(): JSX.Element | null {
        const {
            dangerouslyTranslateWithHTML: translateKey,
            paramValue,
        } = this.props;

        if (paramValue !== DEFAULT_STAT_VALUE) {
            return null;
        }

        return (
            <>
                <div className="sitegen-fr-invitee__message">
                    {translateKey(TEXT_KEYS.NOTE)}
                </div>
                <div
                    className="sitegen-fr-invitee__cta-button"
                    onClick={this.buyAction}
                >
                    {translateKey(TEXT_KEYS.BUTTON_BUY)}
                </div>
            </>
        );
    }

    public renderInviteeRewardImage(): JSX.Element | null {
        const {
            dangerouslyTranslateWithHTML: translateKey,
            inviteeRewardImageSrc
        } = this.props;

        return <div className="sitegen-fr-invitee__image">
            {inviteeRewardImageSrc
                ? <div className="sitegen-fr-invitee__image-photo">
                    <img src={inviteeRewardImageSrc} alt=""/>
                </div>
                : null
            }

            <div className="sitegen-fr-invitee__image-title">
                {translateKey(TEXT_KEYS.REWARD_DESCRIPTION)}
            </div>
        </div>;
    }

    public render(): JSX.Element {
        const {
            dangerouslyTranslateWithHTML: translateKey,
            paramThreshold,
            paramValue: statValue,
            invitationInfo,
            statsFormatting
        } = this.props;

        const formattedParamTreshold = formatUnit(paramThreshold, statsFormatting);
        const formattedStatValue = formatUnit(statValue, statsFormatting);
        const title: string = translateKey(TEXT_KEYS.TITLE);
        const status: string = translateKey(TEXT_KEYS.STATUS, {
            statValue: formattedStatValue,
            paramThreshold: formattedParamTreshold
        });
        const description: string = translateKey(TEXT_KEYS.DESCRIPTION, {
            username: invitationInfo.username,
            platform: invitationInfo.platformId,
            paramThreshold: formattedParamTreshold
        });

        return (
            <div className="sitegen-fr-invitee">
                <div className="sitegen-fr-invitee__caption">
                    {translateKey(TEXT_KEYS.CAPTION)}
                </div>
                <h2 className="sitegen-fr-invitee__title">{title}</h2>
                <div className="sitegen-fr-invitee__content">
                    <div className="sitegen-fr-invitee__content-title">{status}</div>
                    <div className="sitegen-fr-invitee__content-description">{description}</div>

                    {this.renderInviteeRewardImage()}
                    {this.renderButton()}
                </div>
            </div>
        );
    }

    private buyAction = () => {
        AnalyticsService.sendClickEvent(INVITEE_ANALYTICS(BUTTON_BUY_ANALYTICS_ACTION));
    };
}

export const InviteeWithTranslations = translate()(Invitee);
